import { Color, DefaultValue, getDefaultTransition, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

interface NavItemProps {
  $isSelected?: boolean
}

export const NavItem = styled.div<NavItemProps>`
  display: flex;
  align-items: center;
  gap: ${Spacing.S8};
  height: 34px;
  padding: ${Spacing.S8} ${Spacing.S12};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${({ $isSelected }) => ($isSelected ? Color.Grey100 : 'inherit')};
  color: ${Color.Grey950};
  cursor: pointer;
  ${getDefaultTransition('background-color')}

  &:hover {
    background-color: ${Color.Grey100};
  }
`

export const NavItemWrapper = styled.div`
  padding: ${Spacing.S16};
  border-bottom: 1px solid ${Color.Grey200};
`

export const CountBadgeWrapper = styled.div`
  margin-left: auto;
`
